import React from "react";

const getStrength = (pwd) => {
  if (!pwd) return 0;
  let score = 0;
  if (pwd?.length >= 8) score++;
  if (/[A-Z]/?.test(pwd)) score++;
  if (/[0-9]/?.test(pwd)) score++;
  if (/[^A-Za-z0-9]/?.test(pwd)) score++;
  return score;
};

const STRENGTH_CONFIG = [
  { label: "", barColor: "", textColor: "" },
  { label: "Weak", barColor: "bg-red-500", textColor: "text-red-400" },
  { label: "Fair", barColor: "bg-amber-500", textColor: "text-amber-400" },
  { label: "Good", barColor: "bg-yellow-400", textColor: "text-yellow-400" },
  { label: "Strong", barColor: "bg-emerald-500", textColor: "text-emerald-400" },
];

const REQUIREMENTS = [
  { label: "At least 8 characters", test: (p) => p?.length >= 8 },
  { label: "One uppercase letter", test: (p) => /[A-Z]/?.test(p) },
  { label: "One number", test: (p) => /[0-9]/?.test(p) },
  { label: "One special character", test: (p) => /[^A-Za-z0-9]/?.test(p) },
];

export default function PasswordStrengthMeter({ password }) {
  if (!password) return null;
  const strength = getStrength(password);
  const config = STRENGTH_CONFIG?.[strength];

  return (
    <div className="mt-2.5 space-y-2">
      {/* Strength bars */}
      <div className="flex gap-1">
        {[1, 2, 3, 4]?.map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-all duration-300 ${
              i <= strength ? config?.barColor : "bg-white/10"
            }`}
          />
        ))}
      </div>
      {strength > 0 && (
        <p className={`text-xs font-caption ${config?.textColor}`}>
          {config?.label} password
        </p>
      )}
      {/* Requirements checklist */}
      <div className="grid grid-cols-2 gap-1 pt-1">
        {REQUIREMENTS?.map((req, idx) => {
          const met = req?.test(password);
          return (
            <div key={idx} className="flex items-center gap-1.5">
              <div className={`w-3.5 h-3.5 rounded-full flex items-center justify-center transition-all duration-200 ${
                met ? "bg-emerald-500/20" : "bg-white/5"
              }`}>
                <svg viewBox="0 0 12 12" className={`w-2 h-2 transition-all duration-200 ${met ? "text-emerald-400" : "text-slate-600"}`} fill="none">
                  <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <span className={`text-xs font-caption transition-colors duration-200 ${
                met ? "text-emerald-400" : "text-slate-500"
              }`}>
                {req?.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
